<template>
    <div class="modal fade text-left" id="imageCropper" tabindex="-1" aria-labelledby="myModalLabel17"
            style="padding-right: 15px;" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModel('#imageCropper')">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <cropper v-if='educationStore.img' class="cropper" :src="educationStore.img" :stencil-props="{
                        aspectRatio: 4 / 2
                    }" @change="educationStore.change" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary waves-effect waves-float waves-light"
                        data-dismiss="modal" @click="saveCropped">Accept</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Cropper } from 'vue-advanced-cropper'
    import 'vue-advanced-cropper/dist/style.css';
    import {useEducationStore} from '../../../stores/EducationStore.js'
    import { closeModal } from '../../../utilities/_helpers'
    export default {
        components:{
            Cropper
        },
        setup(){
            return{
                educationStore : useEducationStore(),
                closeModal:closeModal
            }
        },
        methods: {
            saveCropped(){
                this.closeModal('#imageCropper')
            }
        },
    }
</script>